import { IconPhoto } from '@tabler/icons-react'
import { Rule } from 'antd/lib/form'

import { ImageCaptureBlock as RenderImageCaptureBlock } from '../../templateRenderer/CaptureBlocks/ImageCaptureBlock'
import { ImageCaptureBlock } from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  FORBIDDEN_IN_APP,
  InputField,
  TypeOption,
} from './_BaseBlockConfig'

import { FileUploadResult } from '@/hooks/useAttachmentUpload'

class Config extends BaseBlockConfig<ImageCaptureBlock> {
  public override kind = 'capture' as const
  public override type = 'image' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Image (deprecated)',
    icon: IconPhoto,
    helpText: 'Upload a single image',
    forbiddenTemplateTypes: FORBIDDEN_IN_APP,
  }

  public override blockFieldsConfig: Field[] = [
    {
      name: 'altText',
      label: 'Alt text',
      helpText: "The text that will be displayed if your image doesn't load",
      field: InputField,
    },
    {
      name: 'caption',
      label: 'Caption',
      helpText: 'The text that will be displayed along side your image',
      field: InputField,
    },
  ]

  public override mapFormValueToBlock(
    block: ImageCaptureBlock,
    value: FileUploadResult[]
  ): ImageCaptureBlock {
    if (!value?.length) {
      return { ...block, attachmentId: null, key: null, url: null }
    }

    const fileUploadResult = value[0]

    if (!fileUploadResult) {
      return { ...block, attachmentId: null, key: null, url: null }
    }

    return {
      ...block,
      attachmentId: fileUploadResult.attachmentId,
      key: fileUploadResult.key,
    }
  }

  public override renderBlock(
    block: ImageCaptureBlock,
    rules?: Rule[]
  ): React.ReactNode {
    return <RenderImageCaptureBlock block={block} rules={rules} />
  }
}

export const ImageCaptureBlockConfig = new Config()
